import React from 'react';
import { careCards } from './data';
import './Styles/Care.scss';

const Care=()=>{
    return(
        <div className="care-about">
            <h1>We care about our HostDesigner</h1>
            <p>To be able to bring your (___) self to work everyday, we want you to feel your best</p>
            <ul>
                {careCards.map((item) =>{
                    return(
                        <li>
                            <div className="circle">
         
                            </div>
                            <img src={item.icon} />
                            <h2>{item.title}</h2>
                            <p>{item.desc}</p>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
};
export default Care ;